/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { CreateFileRoute, FileRoutesByPath } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SpinnerRouteImport } from './routes/spinner'
import { Route as AuthorizeRouteImport } from './routes/authorize'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthSignoutRouteImport } from './routes/auth.signout'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/organizations'
import { Route as AuthenticatedMyIncidentsRouteImport } from './routes/_authenticated/my-incidents'
import { Route as AuthenticatedAssignedIncidentsRouteImport } from './routes/_authenticated/assigned-incidents'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedOrgIdRouteImport } from './routes/_authenticated/$orgId'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignOutRouteImport } from './routes/(auth)/sign-out'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account.index'
import { Route as AuthenticatedOrgIdIndexRouteImport } from './routes/_authenticated/$orgId.index'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedAccountNotificationsRouteImport } from './routes/_authenticated/account.notifications'
import { Route as AuthenticatedAccountMembershipsRouteImport } from './routes/_authenticated/account.memberships'
import { Route as AuthenticatedAccountCloseRouteImport } from './routes/_authenticated/account.close'
import { Route as AuthenticatedOrgIdGroupsRouteImport } from './routes/_authenticated/$orgId.groups'
import { Route as AuthenticatedOrgIdSettingsRouteRouteImport } from './routes/_authenticated/$orgId.settings.route'
import { Route as AuthenticatedOrgIdDashboardRouteRouteImport } from './routes/_authenticated/$orgId.dashboard.route'
import { Route as AuthenticatedOrgIdMembersIndexRouteImport } from './routes/_authenticated/$orgId.members.index'
import { Route as AuthenticatedOrgIdIncidentsIndexRouteImport } from './routes/_authenticated/$orgId.incidents.index'
import { Route as AuthenticatedOrgIdGuardmeIndexRouteImport } from './routes/_authenticated/$orgId.guardme.index'
import { Route as AuthenticatedOrgIdDashboardIndexRouteImport } from './routes/_authenticated/$orgId.dashboard.index'
import { Route as AuthenticatedOrgIdCheckInIndexRouteImport } from './routes/_authenticated/$orgId.check-in.index'
import { Route as AuthenticatedOrgIdCheckInReportsIndexRouteImport } from './routes/_authenticated/$orgId.check-in-reports.index'
import { Route as AuthenticatedOrgIdSettingsPlacesRouteImport } from './routes/_authenticated/$orgId.settings.places'
import { Route as AuthenticatedOrgIdSettingsNotificationsRouteImport } from './routes/_authenticated/$orgId.settings.notifications'
import { Route as AuthenticatedOrgIdSettingsIntegrationsRouteImport } from './routes/_authenticated/$orgId.settings.integrations'
import { Route as AuthenticatedOrgIdSettingsIncidentTypesRouteImport } from './routes/_authenticated/$orgId.settings.incident-types'
import { Route as AuthenticatedOrgIdSettingsGeneralRouteImport } from './routes/_authenticated/$orgId.settings.general'
import { Route as AuthenticatedOrgIdSettingsBillingRouteImport } from './routes/_authenticated/$orgId.settings.billing'
import { Route as AuthenticatedOrgIdMembersIdRouteImport } from './routes/_authenticated/$orgId.members.$id'
import { Route as AuthenticatedOrgIdIncidentsNewRouteImport } from './routes/_authenticated/$orgId.incidents.new'
import { Route as AuthenticatedOrgIdIncidentsIdRouteImport } from './routes/_authenticated/$orgId.incidents.$id'
import { Route as AuthenticatedOrgIdGuardmeIdRouteImport } from './routes/_authenticated/$orgId.guardme.$id'
import { Route as AuthenticatedOrgIdDashboardReportsRouteImport } from './routes/_authenticated/$orgId.dashboard.reports'
import { Route as AuthenticatedOrgIdDashboardIncidentsRouteImport } from './routes/_authenticated/$orgId.dashboard.incidents'
import { Route as AuthenticatedOrgIdDashboardGuardmeRouteImport } from './routes/_authenticated/$orgId.dashboard.guardme'
import { Route as AuthenticatedOrgIdCheckInIdRouteImport } from './routes/_authenticated/$orgId.check-in.$id'
import { Route as AuthenticatedOrgIdCheckInReportsIdRouteImport } from './routes/_authenticated/$orgId.check-in-reports.$id'

const SpinnerRoute = SpinnerRouteImport.update({
  id: '/spinner',
  path: '/spinner',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthorizeRoute = AuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthSignoutRoute = AuthSignoutRouteImport.update({
  id: '/auth/signout',
  path: '/auth/signout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrganizationsRoute =
  AuthenticatedOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMyIncidentsRoute =
  AuthenticatedMyIncidentsRouteImport.update({
    id: '/my-incidents',
    path: '/my-incidents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssignedIncidentsRoute =
  AuthenticatedAssignedIncidentsRouteImport.update({
    id: '/assigned-incidents',
    path: '/assigned-incidents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrgIdRoute = AuthenticatedOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignOutRoute = authSignOutRouteImport.update({
  id: '/(auth)/sign-out',
  path: '/sign-out',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedOrgIdIndexRoute = AuthenticatedOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedOrgIdRoute,
} as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccountNotificationsRoute =
  AuthenticatedAccountNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountMembershipsRoute =
  AuthenticatedAccountMembershipsRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountCloseRoute =
  AuthenticatedAccountCloseRouteImport.update({
    id: '/close',
    path: '/close',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedOrgIdGroupsRoute =
  AuthenticatedOrgIdGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsRouteRoute =
  AuthenticatedOrgIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdDashboardRouteRoute =
  AuthenticatedOrgIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdMembersIndexRoute =
  AuthenticatedOrgIdMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdIncidentsIndexRoute =
  AuthenticatedOrgIdIncidentsIndexRouteImport.update({
    id: '/incidents/',
    path: '/incidents/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdGuardmeIndexRoute =
  AuthenticatedOrgIdGuardmeIndexRouteImport.update({
    id: '/guardme/',
    path: '/guardme/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdDashboardIndexRoute =
  AuthenticatedOrgIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgIdDashboardRouteRoute,
  } as any)
const AuthenticatedOrgIdCheckInIndexRoute =
  AuthenticatedOrgIdCheckInIndexRouteImport.update({
    id: '/check-in/',
    path: '/check-in/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCheckInReportsIndexRoute =
  AuthenticatedOrgIdCheckInReportsIndexRouteImport.update({
    id: '/check-in-reports/',
    path: '/check-in-reports/',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdSettingsPlacesRoute =
  AuthenticatedOrgIdSettingsPlacesRouteImport.update({
    id: '/places',
    path: '/places',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdSettingsNotificationsRoute =
  AuthenticatedOrgIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdSettingsIntegrationsRoute =
  AuthenticatedOrgIdSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdSettingsIncidentTypesRoute =
  AuthenticatedOrgIdSettingsIncidentTypesRouteImport.update({
    id: '/incident-types',
    path: '/incident-types',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdSettingsGeneralRoute =
  AuthenticatedOrgIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdSettingsBillingRoute =
  AuthenticatedOrgIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedOrgIdSettingsRouteRoute,
  } as any)
const AuthenticatedOrgIdMembersIdRoute =
  AuthenticatedOrgIdMembersIdRouteImport.update({
    id: '/members/$id',
    path: '/members/$id',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdIncidentsNewRoute =
  AuthenticatedOrgIdIncidentsNewRouteImport.update({
    id: '/incidents/new',
    path: '/incidents/new',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdIncidentsIdRoute =
  AuthenticatedOrgIdIncidentsIdRouteImport.update({
    id: '/incidents/$id',
    path: '/incidents/$id',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdGuardmeIdRoute =
  AuthenticatedOrgIdGuardmeIdRouteImport.update({
    id: '/guardme/$id',
    path: '/guardme/$id',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdDashboardReportsRoute =
  AuthenticatedOrgIdDashboardReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedOrgIdDashboardRouteRoute,
  } as any)
const AuthenticatedOrgIdDashboardIncidentsRoute =
  AuthenticatedOrgIdDashboardIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => AuthenticatedOrgIdDashboardRouteRoute,
  } as any)
const AuthenticatedOrgIdDashboardGuardmeRoute =
  AuthenticatedOrgIdDashboardGuardmeRouteImport.update({
    id: '/guardme',
    path: '/guardme',
    getParentRoute: () => AuthenticatedOrgIdDashboardRouteRoute,
  } as any)
const AuthenticatedOrgIdCheckInIdRoute =
  AuthenticatedOrgIdCheckInIdRouteImport.update({
    id: '/check-in/$id',
    path: '/check-in/$id',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)
const AuthenticatedOrgIdCheckInReportsIdRoute =
  AuthenticatedOrgIdCheckInReportsIdRouteImport.update({
    id: '/check-in-reports/$id',
    path: '/check-in-reports/$id',
    getParentRoute: () => AuthenticatedOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/authorize': typeof AuthorizeRoute
  '/spinner': typeof SpinnerRoute
  '/sign-in': typeof authSignInRoute
  '/sign-out': typeof authSignOutRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/$orgId': typeof AuthenticatedOrgIdRouteWithChildren
  '/account': typeof AuthenticatedAccountRouteWithChildren
  '/assigned-incidents': typeof AuthenticatedAssignedIncidentsRoute
  '/my-incidents': typeof AuthenticatedMyIncidentsRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/': typeof AuthenticatedIndexRoute
  '/$orgId/dashboard': typeof AuthenticatedOrgIdDashboardRouteRouteWithChildren
  '/$orgId/settings': typeof AuthenticatedOrgIdSettingsRouteRouteWithChildren
  '/$orgId/groups': typeof AuthenticatedOrgIdGroupsRoute
  '/account/close': typeof AuthenticatedAccountCloseRoute
  '/account/memberships': typeof AuthenticatedAccountMembershipsRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/$orgId/': typeof AuthenticatedOrgIdIndexRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/$orgId/check-in-reports/$id': typeof AuthenticatedOrgIdCheckInReportsIdRoute
  '/$orgId/check-in/$id': typeof AuthenticatedOrgIdCheckInIdRoute
  '/$orgId/dashboard/guardme': typeof AuthenticatedOrgIdDashboardGuardmeRoute
  '/$orgId/dashboard/incidents': typeof AuthenticatedOrgIdDashboardIncidentsRoute
  '/$orgId/dashboard/reports': typeof AuthenticatedOrgIdDashboardReportsRoute
  '/$orgId/guardme/$id': typeof AuthenticatedOrgIdGuardmeIdRoute
  '/$orgId/incidents/$id': typeof AuthenticatedOrgIdIncidentsIdRoute
  '/$orgId/incidents/new': typeof AuthenticatedOrgIdIncidentsNewRoute
  '/$orgId/members/$id': typeof AuthenticatedOrgIdMembersIdRoute
  '/$orgId/settings/billing': typeof AuthenticatedOrgIdSettingsBillingRoute
  '/$orgId/settings/general': typeof AuthenticatedOrgIdSettingsGeneralRoute
  '/$orgId/settings/incident-types': typeof AuthenticatedOrgIdSettingsIncidentTypesRoute
  '/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsRoute
  '/$orgId/settings/notifications': typeof AuthenticatedOrgIdSettingsNotificationsRoute
  '/$orgId/settings/places': typeof AuthenticatedOrgIdSettingsPlacesRoute
  '/$orgId/check-in-reports': typeof AuthenticatedOrgIdCheckInReportsIndexRoute
  '/$orgId/check-in': typeof AuthenticatedOrgIdCheckInIndexRoute
  '/$orgId/dashboard/': typeof AuthenticatedOrgIdDashboardIndexRoute
  '/$orgId/guardme': typeof AuthenticatedOrgIdGuardmeIndexRoute
  '/$orgId/incidents': typeof AuthenticatedOrgIdIncidentsIndexRoute
  '/$orgId/members': typeof AuthenticatedOrgIdMembersIndexRoute
}
export interface FileRoutesByTo {
  '/authorize': typeof AuthorizeRoute
  '/spinner': typeof SpinnerRoute
  '/sign-in': typeof authSignInRoute
  '/sign-out': typeof authSignOutRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/assigned-incidents': typeof AuthenticatedAssignedIncidentsRoute
  '/my-incidents': typeof AuthenticatedMyIncidentsRoute
  '/organizations': typeof AuthenticatedOrganizationsRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/': typeof AuthenticatedIndexRoute
  '/$orgId/settings': typeof AuthenticatedOrgIdSettingsRouteRouteWithChildren
  '/$orgId/groups': typeof AuthenticatedOrgIdGroupsRoute
  '/account/close': typeof AuthenticatedAccountCloseRoute
  '/account/memberships': typeof AuthenticatedAccountMembershipsRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/$orgId': typeof AuthenticatedOrgIdIndexRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/$orgId/check-in-reports/$id': typeof AuthenticatedOrgIdCheckInReportsIdRoute
  '/$orgId/check-in/$id': typeof AuthenticatedOrgIdCheckInIdRoute
  '/$orgId/dashboard/guardme': typeof AuthenticatedOrgIdDashboardGuardmeRoute
  '/$orgId/dashboard/incidents': typeof AuthenticatedOrgIdDashboardIncidentsRoute
  '/$orgId/dashboard/reports': typeof AuthenticatedOrgIdDashboardReportsRoute
  '/$orgId/guardme/$id': typeof AuthenticatedOrgIdGuardmeIdRoute
  '/$orgId/incidents/$id': typeof AuthenticatedOrgIdIncidentsIdRoute
  '/$orgId/incidents/new': typeof AuthenticatedOrgIdIncidentsNewRoute
  '/$orgId/members/$id': typeof AuthenticatedOrgIdMembersIdRoute
  '/$orgId/settings/billing': typeof AuthenticatedOrgIdSettingsBillingRoute
  '/$orgId/settings/general': typeof AuthenticatedOrgIdSettingsGeneralRoute
  '/$orgId/settings/incident-types': typeof AuthenticatedOrgIdSettingsIncidentTypesRoute
  '/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsRoute
  '/$orgId/settings/notifications': typeof AuthenticatedOrgIdSettingsNotificationsRoute
  '/$orgId/settings/places': typeof AuthenticatedOrgIdSettingsPlacesRoute
  '/$orgId/check-in-reports': typeof AuthenticatedOrgIdCheckInReportsIndexRoute
  '/$orgId/check-in': typeof AuthenticatedOrgIdCheckInIndexRoute
  '/$orgId/dashboard': typeof AuthenticatedOrgIdDashboardIndexRoute
  '/$orgId/guardme': typeof AuthenticatedOrgIdGuardmeIndexRoute
  '/$orgId/incidents': typeof AuthenticatedOrgIdIncidentsIndexRoute
  '/$orgId/members': typeof AuthenticatedOrgIdMembersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/authorize': typeof AuthorizeRoute
  '/spinner': typeof SpinnerRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-out': typeof authSignOutRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/$orgId': typeof AuthenticatedOrgIdRouteWithChildren
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/assigned-incidents': typeof AuthenticatedAssignedIncidentsRoute
  '/_authenticated/my-incidents': typeof AuthenticatedMyIncidentsRoute
  '/_authenticated/organizations': typeof AuthenticatedOrganizationsRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$orgId/dashboard': typeof AuthenticatedOrgIdDashboardRouteRouteWithChildren
  '/_authenticated/$orgId/settings': typeof AuthenticatedOrgIdSettingsRouteRouteWithChildren
  '/_authenticated/$orgId/groups': typeof AuthenticatedOrgIdGroupsRoute
  '/_authenticated/account/close': typeof AuthenticatedAccountCloseRoute
  '/_authenticated/account/memberships': typeof AuthenticatedAccountMembershipsRoute
  '/_authenticated/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/$orgId/': typeof AuthenticatedOrgIdIndexRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/$orgId/check-in-reports/$id': typeof AuthenticatedOrgIdCheckInReportsIdRoute
  '/_authenticated/$orgId/check-in/$id': typeof AuthenticatedOrgIdCheckInIdRoute
  '/_authenticated/$orgId/dashboard/guardme': typeof AuthenticatedOrgIdDashboardGuardmeRoute
  '/_authenticated/$orgId/dashboard/incidents': typeof AuthenticatedOrgIdDashboardIncidentsRoute
  '/_authenticated/$orgId/dashboard/reports': typeof AuthenticatedOrgIdDashboardReportsRoute
  '/_authenticated/$orgId/guardme/$id': typeof AuthenticatedOrgIdGuardmeIdRoute
  '/_authenticated/$orgId/incidents/$id': typeof AuthenticatedOrgIdIncidentsIdRoute
  '/_authenticated/$orgId/incidents/new': typeof AuthenticatedOrgIdIncidentsNewRoute
  '/_authenticated/$orgId/members/$id': typeof AuthenticatedOrgIdMembersIdRoute
  '/_authenticated/$orgId/settings/billing': typeof AuthenticatedOrgIdSettingsBillingRoute
  '/_authenticated/$orgId/settings/general': typeof AuthenticatedOrgIdSettingsGeneralRoute
  '/_authenticated/$orgId/settings/incident-types': typeof AuthenticatedOrgIdSettingsIncidentTypesRoute
  '/_authenticated/$orgId/settings/integrations': typeof AuthenticatedOrgIdSettingsIntegrationsRoute
  '/_authenticated/$orgId/settings/notifications': typeof AuthenticatedOrgIdSettingsNotificationsRoute
  '/_authenticated/$orgId/settings/places': typeof AuthenticatedOrgIdSettingsPlacesRoute
  '/_authenticated/$orgId/check-in-reports/': typeof AuthenticatedOrgIdCheckInReportsIndexRoute
  '/_authenticated/$orgId/check-in/': typeof AuthenticatedOrgIdCheckInIndexRoute
  '/_authenticated/$orgId/dashboard/': typeof AuthenticatedOrgIdDashboardIndexRoute
  '/_authenticated/$orgId/guardme/': typeof AuthenticatedOrgIdGuardmeIndexRoute
  '/_authenticated/$orgId/incidents/': typeof AuthenticatedOrgIdIncidentsIndexRoute
  '/_authenticated/$orgId/members/': typeof AuthenticatedOrgIdMembersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/authorize'
    | '/spinner'
    | '/sign-in'
    | '/sign-out'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/$orgId'
    | '/account'
    | '/assigned-incidents'
    | '/my-incidents'
    | '/organizations'
    | '/auth/signout'
    | '/'
    | '/$orgId/dashboard'
    | '/$orgId/settings'
    | '/$orgId/groups'
    | '/account/close'
    | '/account/memberships'
    | '/account/notifications'
    | '/errors/$error'
    | '/$orgId/'
    | '/account/'
    | '/$orgId/check-in-reports/$id'
    | '/$orgId/check-in/$id'
    | '/$orgId/dashboard/guardme'
    | '/$orgId/dashboard/incidents'
    | '/$orgId/dashboard/reports'
    | '/$orgId/guardme/$id'
    | '/$orgId/incidents/$id'
    | '/$orgId/incidents/new'
    | '/$orgId/members/$id'
    | '/$orgId/settings/billing'
    | '/$orgId/settings/general'
    | '/$orgId/settings/incident-types'
    | '/$orgId/settings/integrations'
    | '/$orgId/settings/notifications'
    | '/$orgId/settings/places'
    | '/$orgId/check-in-reports'
    | '/$orgId/check-in'
    | '/$orgId/dashboard/'
    | '/$orgId/guardme'
    | '/$orgId/incidents'
    | '/$orgId/members'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/authorize'
    | '/spinner'
    | '/sign-in'
    | '/sign-out'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/assigned-incidents'
    | '/my-incidents'
    | '/organizations'
    | '/auth/signout'
    | '/'
    | '/$orgId/settings'
    | '/$orgId/groups'
    | '/account/close'
    | '/account/memberships'
    | '/account/notifications'
    | '/errors/$error'
    | '/$orgId'
    | '/account'
    | '/$orgId/check-in-reports/$id'
    | '/$orgId/check-in/$id'
    | '/$orgId/dashboard/guardme'
    | '/$orgId/dashboard/incidents'
    | '/$orgId/dashboard/reports'
    | '/$orgId/guardme/$id'
    | '/$orgId/incidents/$id'
    | '/$orgId/incidents/new'
    | '/$orgId/members/$id'
    | '/$orgId/settings/billing'
    | '/$orgId/settings/general'
    | '/$orgId/settings/incident-types'
    | '/$orgId/settings/integrations'
    | '/$orgId/settings/notifications'
    | '/$orgId/settings/places'
    | '/$orgId/check-in-reports'
    | '/$orgId/check-in'
    | '/$orgId/dashboard'
    | '/$orgId/guardme'
    | '/$orgId/incidents'
    | '/$orgId/members'
  id:
    | '__root__'
    | '/_authenticated'
    | '/authorize'
    | '/spinner'
    | '/(auth)/sign-in'
    | '/(auth)/sign-out'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/$orgId'
    | '/_authenticated/account'
    | '/_authenticated/assigned-incidents'
    | '/_authenticated/my-incidents'
    | '/_authenticated/organizations'
    | '/auth/signout'
    | '/_authenticated/'
    | '/_authenticated/$orgId/dashboard'
    | '/_authenticated/$orgId/settings'
    | '/_authenticated/$orgId/groups'
    | '/_authenticated/account/close'
    | '/_authenticated/account/memberships'
    | '/_authenticated/account/notifications'
    | '/_authenticated/errors/$error'
    | '/_authenticated/$orgId/'
    | '/_authenticated/account/'
    | '/_authenticated/$orgId/check-in-reports/$id'
    | '/_authenticated/$orgId/check-in/$id'
    | '/_authenticated/$orgId/dashboard/guardme'
    | '/_authenticated/$orgId/dashboard/incidents'
    | '/_authenticated/$orgId/dashboard/reports'
    | '/_authenticated/$orgId/guardme/$id'
    | '/_authenticated/$orgId/incidents/$id'
    | '/_authenticated/$orgId/incidents/new'
    | '/_authenticated/$orgId/members/$id'
    | '/_authenticated/$orgId/settings/billing'
    | '/_authenticated/$orgId/settings/general'
    | '/_authenticated/$orgId/settings/incident-types'
    | '/_authenticated/$orgId/settings/integrations'
    | '/_authenticated/$orgId/settings/notifications'
    | '/_authenticated/$orgId/settings/places'
    | '/_authenticated/$orgId/check-in-reports/'
    | '/_authenticated/$orgId/check-in/'
    | '/_authenticated/$orgId/dashboard/'
    | '/_authenticated/$orgId/guardme/'
    | '/_authenticated/$orgId/incidents/'
    | '/_authenticated/$orgId/members/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AuthorizeRoute: typeof AuthorizeRoute
  SpinnerRoute: typeof SpinnerRoute
  authSignInRoute: typeof authSignInRoute
  authSignOutRoute: typeof authSignOutRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  AuthSignoutRoute: typeof AuthSignoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/spinner': {
      id: '/spinner'
      path: '/spinner'
      fullPath: '/spinner'
      preLoaderRoute: typeof SpinnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authorize': {
      id: '/authorize'
      path: '/authorize'
      fullPath: '/authorize'
      preLoaderRoute: typeof AuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/signout': {
      id: '/auth/signout'
      path: '/auth/signout'
      fullPath: '/auth/signout'
      preLoaderRoute: typeof AuthSignoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/organizations': {
      id: '/_authenticated/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-incidents': {
      id: '/_authenticated/my-incidents'
      path: '/my-incidents'
      fullPath: '/my-incidents'
      preLoaderRoute: typeof AuthenticatedMyIncidentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assigned-incidents': {
      id: '/_authenticated/assigned-incidents'
      path: '/assigned-incidents'
      fullPath: '/assigned-incidents'
      preLoaderRoute: typeof AuthenticatedAssignedIncidentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$orgId': {
      id: '/_authenticated/$orgId'
      path: '/$orgId'
      fullPath: '/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-out': {
      id: '/(auth)/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof authSignOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/$orgId/': {
      id: '/_authenticated/$orgId/'
      path: '/'
      fullPath: '/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/account/notifications': {
      id: '/_authenticated/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AuthenticatedAccountNotificationsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/memberships': {
      id: '/_authenticated/account/memberships'
      path: '/memberships'
      fullPath: '/account/memberships'
      preLoaderRoute: typeof AuthenticatedAccountMembershipsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/close': {
      id: '/_authenticated/account/close'
      path: '/close'
      fullPath: '/account/close'
      preLoaderRoute: typeof AuthenticatedAccountCloseRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/$orgId/groups': {
      id: '/_authenticated/$orgId/groups'
      path: '/groups'
      fullPath: '/$orgId/groups'
      preLoaderRoute: typeof AuthenticatedOrgIdGroupsRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings': {
      id: '/_authenticated/$orgId/settings'
      path: '/settings'
      fullPath: '/$orgId/settings'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/dashboard': {
      id: '/_authenticated/$orgId/dashboard'
      path: '/dashboard'
      fullPath: '/$orgId/dashboard'
      preLoaderRoute: typeof AuthenticatedOrgIdDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/members/': {
      id: '/_authenticated/$orgId/members/'
      path: '/members'
      fullPath: '/$orgId/members'
      preLoaderRoute: typeof AuthenticatedOrgIdMembersIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/incidents/': {
      id: '/_authenticated/$orgId/incidents/'
      path: '/incidents'
      fullPath: '/$orgId/incidents'
      preLoaderRoute: typeof AuthenticatedOrgIdIncidentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/guardme/': {
      id: '/_authenticated/$orgId/guardme/'
      path: '/guardme'
      fullPath: '/$orgId/guardme'
      preLoaderRoute: typeof AuthenticatedOrgIdGuardmeIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/dashboard/': {
      id: '/_authenticated/$orgId/dashboard/'
      path: '/'
      fullPath: '/$orgId/dashboard/'
      preLoaderRoute: typeof AuthenticatedOrgIdDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdDashboardRouteRoute
    }
    '/_authenticated/$orgId/check-in/': {
      id: '/_authenticated/$orgId/check-in/'
      path: '/check-in'
      fullPath: '/$orgId/check-in'
      preLoaderRoute: typeof AuthenticatedOrgIdCheckInIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/check-in-reports/': {
      id: '/_authenticated/$orgId/check-in-reports/'
      path: '/check-in-reports'
      fullPath: '/$orgId/check-in-reports'
      preLoaderRoute: typeof AuthenticatedOrgIdCheckInReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/settings/places': {
      id: '/_authenticated/$orgId/settings/places'
      path: '/places'
      fullPath: '/$orgId/settings/places'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsPlacesRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/settings/notifications': {
      id: '/_authenticated/$orgId/settings/notifications'
      path: '/notifications'
      fullPath: '/$orgId/settings/notifications'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/settings/integrations': {
      id: '/_authenticated/$orgId/settings/integrations'
      path: '/integrations'
      fullPath: '/$orgId/settings/integrations'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/settings/incident-types': {
      id: '/_authenticated/$orgId/settings/incident-types'
      path: '/incident-types'
      fullPath: '/$orgId/settings/incident-types'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsIncidentTypesRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/settings/general': {
      id: '/_authenticated/$orgId/settings/general'
      path: '/general'
      fullPath: '/$orgId/settings/general'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsGeneralRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/settings/billing': {
      id: '/_authenticated/$orgId/settings/billing'
      path: '/billing'
      fullPath: '/$orgId/settings/billing'
      preLoaderRoute: typeof AuthenticatedOrgIdSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedOrgIdSettingsRouteRoute
    }
    '/_authenticated/$orgId/members/$id': {
      id: '/_authenticated/$orgId/members/$id'
      path: '/members/$id'
      fullPath: '/$orgId/members/$id'
      preLoaderRoute: typeof AuthenticatedOrgIdMembersIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/incidents/new': {
      id: '/_authenticated/$orgId/incidents/new'
      path: '/incidents/new'
      fullPath: '/$orgId/incidents/new'
      preLoaderRoute: typeof AuthenticatedOrgIdIncidentsNewRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/incidents/$id': {
      id: '/_authenticated/$orgId/incidents/$id'
      path: '/incidents/$id'
      fullPath: '/$orgId/incidents/$id'
      preLoaderRoute: typeof AuthenticatedOrgIdIncidentsIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/guardme/$id': {
      id: '/_authenticated/$orgId/guardme/$id'
      path: '/guardme/$id'
      fullPath: '/$orgId/guardme/$id'
      preLoaderRoute: typeof AuthenticatedOrgIdGuardmeIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/dashboard/reports': {
      id: '/_authenticated/$orgId/dashboard/reports'
      path: '/reports'
      fullPath: '/$orgId/dashboard/reports'
      preLoaderRoute: typeof AuthenticatedOrgIdDashboardReportsRouteImport
      parentRoute: typeof AuthenticatedOrgIdDashboardRouteRoute
    }
    '/_authenticated/$orgId/dashboard/incidents': {
      id: '/_authenticated/$orgId/dashboard/incidents'
      path: '/incidents'
      fullPath: '/$orgId/dashboard/incidents'
      preLoaderRoute: typeof AuthenticatedOrgIdDashboardIncidentsRouteImport
      parentRoute: typeof AuthenticatedOrgIdDashboardRouteRoute
    }
    '/_authenticated/$orgId/dashboard/guardme': {
      id: '/_authenticated/$orgId/dashboard/guardme'
      path: '/guardme'
      fullPath: '/$orgId/dashboard/guardme'
      preLoaderRoute: typeof AuthenticatedOrgIdDashboardGuardmeRouteImport
      parentRoute: typeof AuthenticatedOrgIdDashboardRouteRoute
    }
    '/_authenticated/$orgId/check-in/$id': {
      id: '/_authenticated/$orgId/check-in/$id'
      path: '/check-in/$id'
      fullPath: '/$orgId/check-in/$id'
      preLoaderRoute: typeof AuthenticatedOrgIdCheckInIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
    '/_authenticated/$orgId/check-in-reports/$id': {
      id: '/_authenticated/$orgId/check-in-reports/$id'
      path: '/check-in-reports/$id'
      fullPath: '/$orgId/check-in-reports/$id'
      preLoaderRoute: typeof AuthenticatedOrgIdCheckInReportsIdRouteImport
      parentRoute: typeof AuthenticatedOrgIdRoute
    }
  }
}

declare module './routes/_authenticated/route' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated',
    FileRoutesByPath['/_authenticated']['parentRoute'],
    FileRoutesByPath['/_authenticated']['id'],
    FileRoutesByPath['/_authenticated']['path'],
    FileRoutesByPath['/_authenticated']['fullPath']
  >
}
declare module './routes/authorize' {
  const createFileRoute: CreateFileRoute<
    '/authorize',
    FileRoutesByPath['/authorize']['parentRoute'],
    FileRoutesByPath['/authorize']['id'],
    FileRoutesByPath['/authorize']['path'],
    FileRoutesByPath['/authorize']['fullPath']
  >
}
declare module './routes/spinner' {
  const createFileRoute: CreateFileRoute<
    '/spinner',
    FileRoutesByPath['/spinner']['parentRoute'],
    FileRoutesByPath['/spinner']['id'],
    FileRoutesByPath['/spinner']['path'],
    FileRoutesByPath['/spinner']['fullPath']
  >
}
declare module './routes/(auth)/sign-in' {
  const createFileRoute: CreateFileRoute<
    '/(auth)/sign-in',
    FileRoutesByPath['/(auth)/sign-in']['parentRoute'],
    FileRoutesByPath['/(auth)/sign-in']['id'],
    FileRoutesByPath['/(auth)/sign-in']['path'],
    FileRoutesByPath['/(auth)/sign-in']['fullPath']
  >
}
declare module './routes/(auth)/sign-out' {
  const createFileRoute: CreateFileRoute<
    '/(auth)/sign-out',
    FileRoutesByPath['/(auth)/sign-out']['parentRoute'],
    FileRoutesByPath['/(auth)/sign-out']['id'],
    FileRoutesByPath['/(auth)/sign-out']['path'],
    FileRoutesByPath['/(auth)/sign-out']['fullPath']
  >
}
declare module './routes/(errors)/401' {
  const createFileRoute: CreateFileRoute<
    '/(errors)/401',
    FileRoutesByPath['/(errors)/401']['parentRoute'],
    FileRoutesByPath['/(errors)/401']['id'],
    FileRoutesByPath['/(errors)/401']['path'],
    FileRoutesByPath['/(errors)/401']['fullPath']
  >
}
declare module './routes/(errors)/403' {
  const createFileRoute: CreateFileRoute<
    '/(errors)/403',
    FileRoutesByPath['/(errors)/403']['parentRoute'],
    FileRoutesByPath['/(errors)/403']['id'],
    FileRoutesByPath['/(errors)/403']['path'],
    FileRoutesByPath['/(errors)/403']['fullPath']
  >
}
declare module './routes/(errors)/404' {
  const createFileRoute: CreateFileRoute<
    '/(errors)/404',
    FileRoutesByPath['/(errors)/404']['parentRoute'],
    FileRoutesByPath['/(errors)/404']['id'],
    FileRoutesByPath['/(errors)/404']['path'],
    FileRoutesByPath['/(errors)/404']['fullPath']
  >
}
declare module './routes/(errors)/500' {
  const createFileRoute: CreateFileRoute<
    '/(errors)/500',
    FileRoutesByPath['/(errors)/500']['parentRoute'],
    FileRoutesByPath['/(errors)/500']['id'],
    FileRoutesByPath['/(errors)/500']['path'],
    FileRoutesByPath['/(errors)/500']['fullPath']
  >
}
declare module './routes/(errors)/503' {
  const createFileRoute: CreateFileRoute<
    '/(errors)/503',
    FileRoutesByPath['/(errors)/503']['parentRoute'],
    FileRoutesByPath['/(errors)/503']['id'],
    FileRoutesByPath['/(errors)/503']['path'],
    FileRoutesByPath['/(errors)/503']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId',
    FileRoutesByPath['/_authenticated/$orgId']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId']['id'],
    FileRoutesByPath['/_authenticated/$orgId']['path'],
    FileRoutesByPath['/_authenticated/$orgId']['fullPath']
  >
}
declare module './routes/_authenticated/account' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/account',
    FileRoutesByPath['/_authenticated/account']['parentRoute'],
    FileRoutesByPath['/_authenticated/account']['id'],
    FileRoutesByPath['/_authenticated/account']['path'],
    FileRoutesByPath['/_authenticated/account']['fullPath']
  >
}
declare module './routes/_authenticated/assigned-incidents' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/assigned-incidents',
    FileRoutesByPath['/_authenticated/assigned-incidents']['parentRoute'],
    FileRoutesByPath['/_authenticated/assigned-incidents']['id'],
    FileRoutesByPath['/_authenticated/assigned-incidents']['path'],
    FileRoutesByPath['/_authenticated/assigned-incidents']['fullPath']
  >
}
declare module './routes/_authenticated/my-incidents' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/my-incidents',
    FileRoutesByPath['/_authenticated/my-incidents']['parentRoute'],
    FileRoutesByPath['/_authenticated/my-incidents']['id'],
    FileRoutesByPath['/_authenticated/my-incidents']['path'],
    FileRoutesByPath['/_authenticated/my-incidents']['fullPath']
  >
}
declare module './routes/_authenticated/organizations' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/organizations',
    FileRoutesByPath['/_authenticated/organizations']['parentRoute'],
    FileRoutesByPath['/_authenticated/organizations']['id'],
    FileRoutesByPath['/_authenticated/organizations']['path'],
    FileRoutesByPath['/_authenticated/organizations']['fullPath']
  >
}
declare module './routes/auth.signout' {
  const createFileRoute: CreateFileRoute<
    '/auth/signout',
    FileRoutesByPath['/auth/signout']['parentRoute'],
    FileRoutesByPath['/auth/signout']['id'],
    FileRoutesByPath['/auth/signout']['path'],
    FileRoutesByPath['/auth/signout']['fullPath']
  >
}
declare module './routes/_authenticated/index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/',
    FileRoutesByPath['/_authenticated/']['parentRoute'],
    FileRoutesByPath['/_authenticated/']['id'],
    FileRoutesByPath['/_authenticated/']['path'],
    FileRoutesByPath['/_authenticated/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.dashboard.route' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/dashboard',
    FileRoutesByPath['/_authenticated/$orgId/dashboard']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard']['id'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard']['path'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.route' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings',
    FileRoutesByPath['/_authenticated/$orgId/settings']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.groups' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/groups',
    FileRoutesByPath['/_authenticated/$orgId/groups']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/groups']['id'],
    FileRoutesByPath['/_authenticated/$orgId/groups']['path'],
    FileRoutesByPath['/_authenticated/$orgId/groups']['fullPath']
  >
}
declare module './routes/_authenticated/account.close' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/account/close',
    FileRoutesByPath['/_authenticated/account/close']['parentRoute'],
    FileRoutesByPath['/_authenticated/account/close']['id'],
    FileRoutesByPath['/_authenticated/account/close']['path'],
    FileRoutesByPath['/_authenticated/account/close']['fullPath']
  >
}
declare module './routes/_authenticated/account.memberships' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/account/memberships',
    FileRoutesByPath['/_authenticated/account/memberships']['parentRoute'],
    FileRoutesByPath['/_authenticated/account/memberships']['id'],
    FileRoutesByPath['/_authenticated/account/memberships']['path'],
    FileRoutesByPath['/_authenticated/account/memberships']['fullPath']
  >
}
declare module './routes/_authenticated/account.notifications' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/account/notifications',
    FileRoutesByPath['/_authenticated/account/notifications']['parentRoute'],
    FileRoutesByPath['/_authenticated/account/notifications']['id'],
    FileRoutesByPath['/_authenticated/account/notifications']['path'],
    FileRoutesByPath['/_authenticated/account/notifications']['fullPath']
  >
}
declare module './routes/_authenticated/errors/$error' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/errors/$error',
    FileRoutesByPath['/_authenticated/errors/$error']['parentRoute'],
    FileRoutesByPath['/_authenticated/errors/$error']['id'],
    FileRoutesByPath['/_authenticated/errors/$error']['path'],
    FileRoutesByPath['/_authenticated/errors/$error']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/',
    FileRoutesByPath['/_authenticated/$orgId/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/']['fullPath']
  >
}
declare module './routes/_authenticated/account.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/account/',
    FileRoutesByPath['/_authenticated/account/']['parentRoute'],
    FileRoutesByPath['/_authenticated/account/']['id'],
    FileRoutesByPath['/_authenticated/account/']['path'],
    FileRoutesByPath['/_authenticated/account/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.check-in-reports.$id' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/check-in-reports/$id',
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/$id']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/$id']['id'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/$id']['path'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/$id']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.check-in.$id' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/check-in/$id',
    FileRoutesByPath['/_authenticated/$orgId/check-in/$id']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/$id']['id'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/$id']['path'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/$id']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.dashboard.guardme' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/dashboard/guardme',
    FileRoutesByPath['/_authenticated/$orgId/dashboard/guardme']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/guardme']['id'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/guardme']['path'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/guardme']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.dashboard.incidents' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/dashboard/incidents',
    FileRoutesByPath['/_authenticated/$orgId/dashboard/incidents']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/incidents']['id'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/incidents']['path'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/incidents']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.dashboard.reports' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/dashboard/reports',
    FileRoutesByPath['/_authenticated/$orgId/dashboard/reports']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/reports']['id'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/reports']['path'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/reports']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.guardme.$id' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/guardme/$id',
    FileRoutesByPath['/_authenticated/$orgId/guardme/$id']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/$id']['id'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/$id']['path'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/$id']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.incidents.$id' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/incidents/$id',
    FileRoutesByPath['/_authenticated/$orgId/incidents/$id']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/$id']['id'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/$id']['path'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/$id']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.incidents.new' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/incidents/new',
    FileRoutesByPath['/_authenticated/$orgId/incidents/new']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/new']['id'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/new']['path'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/new']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.members.$id' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/members/$id',
    FileRoutesByPath['/_authenticated/$orgId/members/$id']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/members/$id']['id'],
    FileRoutesByPath['/_authenticated/$orgId/members/$id']['path'],
    FileRoutesByPath['/_authenticated/$orgId/members/$id']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.billing' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/billing',
    FileRoutesByPath['/_authenticated/$orgId/settings/billing']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/billing']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/billing']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/billing']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.general' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/general',
    FileRoutesByPath['/_authenticated/$orgId/settings/general']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/general']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/general']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/general']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.incident-types' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/incident-types',
    FileRoutesByPath['/_authenticated/$orgId/settings/incident-types']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/incident-types']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/incident-types']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/incident-types']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.integrations' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/integrations',
    FileRoutesByPath['/_authenticated/$orgId/settings/integrations']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/integrations']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/integrations']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/integrations']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.notifications' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/notifications',
    FileRoutesByPath['/_authenticated/$orgId/settings/notifications']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/notifications']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/notifications']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/notifications']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.settings.places' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/settings/places',
    FileRoutesByPath['/_authenticated/$orgId/settings/places']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/settings/places']['id'],
    FileRoutesByPath['/_authenticated/$orgId/settings/places']['path'],
    FileRoutesByPath['/_authenticated/$orgId/settings/places']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.check-in-reports.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/check-in-reports/',
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/check-in-reports/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.check-in.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/check-in/',
    FileRoutesByPath['/_authenticated/$orgId/check-in/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/check-in/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.dashboard.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/dashboard/',
    FileRoutesByPath['/_authenticated/$orgId/dashboard/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/dashboard/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.guardme.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/guardme/',
    FileRoutesByPath['/_authenticated/$orgId/guardme/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/guardme/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.incidents.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/incidents/',
    FileRoutesByPath['/_authenticated/$orgId/incidents/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/incidents/']['fullPath']
  >
}
declare module './routes/_authenticated/$orgId.members.index' {
  const createFileRoute: CreateFileRoute<
    '/_authenticated/$orgId/members/',
    FileRoutesByPath['/_authenticated/$orgId/members/']['parentRoute'],
    FileRoutesByPath['/_authenticated/$orgId/members/']['id'],
    FileRoutesByPath['/_authenticated/$orgId/members/']['path'],
    FileRoutesByPath['/_authenticated/$orgId/members/']['fullPath']
  >
}

interface AuthenticatedOrgIdDashboardRouteRouteChildren {
  AuthenticatedOrgIdDashboardGuardmeRoute: typeof AuthenticatedOrgIdDashboardGuardmeRoute
  AuthenticatedOrgIdDashboardIncidentsRoute: typeof AuthenticatedOrgIdDashboardIncidentsRoute
  AuthenticatedOrgIdDashboardReportsRoute: typeof AuthenticatedOrgIdDashboardReportsRoute
  AuthenticatedOrgIdDashboardIndexRoute: typeof AuthenticatedOrgIdDashboardIndexRoute
}

const AuthenticatedOrgIdDashboardRouteRouteChildren: AuthenticatedOrgIdDashboardRouteRouteChildren =
  {
    AuthenticatedOrgIdDashboardGuardmeRoute:
      AuthenticatedOrgIdDashboardGuardmeRoute,
    AuthenticatedOrgIdDashboardIncidentsRoute:
      AuthenticatedOrgIdDashboardIncidentsRoute,
    AuthenticatedOrgIdDashboardReportsRoute:
      AuthenticatedOrgIdDashboardReportsRoute,
    AuthenticatedOrgIdDashboardIndexRoute:
      AuthenticatedOrgIdDashboardIndexRoute,
  }

const AuthenticatedOrgIdDashboardRouteRouteWithChildren =
  AuthenticatedOrgIdDashboardRouteRoute._addFileChildren(
    AuthenticatedOrgIdDashboardRouteRouteChildren,
  )

interface AuthenticatedOrgIdSettingsRouteRouteChildren {
  AuthenticatedOrgIdSettingsBillingRoute: typeof AuthenticatedOrgIdSettingsBillingRoute
  AuthenticatedOrgIdSettingsGeneralRoute: typeof AuthenticatedOrgIdSettingsGeneralRoute
  AuthenticatedOrgIdSettingsIncidentTypesRoute: typeof AuthenticatedOrgIdSettingsIncidentTypesRoute
  AuthenticatedOrgIdSettingsIntegrationsRoute: typeof AuthenticatedOrgIdSettingsIntegrationsRoute
  AuthenticatedOrgIdSettingsNotificationsRoute: typeof AuthenticatedOrgIdSettingsNotificationsRoute
  AuthenticatedOrgIdSettingsPlacesRoute: typeof AuthenticatedOrgIdSettingsPlacesRoute
}

const AuthenticatedOrgIdSettingsRouteRouteChildren: AuthenticatedOrgIdSettingsRouteRouteChildren =
  {
    AuthenticatedOrgIdSettingsBillingRoute:
      AuthenticatedOrgIdSettingsBillingRoute,
    AuthenticatedOrgIdSettingsGeneralRoute:
      AuthenticatedOrgIdSettingsGeneralRoute,
    AuthenticatedOrgIdSettingsIncidentTypesRoute:
      AuthenticatedOrgIdSettingsIncidentTypesRoute,
    AuthenticatedOrgIdSettingsIntegrationsRoute:
      AuthenticatedOrgIdSettingsIntegrationsRoute,
    AuthenticatedOrgIdSettingsNotificationsRoute:
      AuthenticatedOrgIdSettingsNotificationsRoute,
    AuthenticatedOrgIdSettingsPlacesRoute:
      AuthenticatedOrgIdSettingsPlacesRoute,
  }

const AuthenticatedOrgIdSettingsRouteRouteWithChildren =
  AuthenticatedOrgIdSettingsRouteRoute._addFileChildren(
    AuthenticatedOrgIdSettingsRouteRouteChildren,
  )

interface AuthenticatedOrgIdRouteChildren {
  AuthenticatedOrgIdDashboardRouteRoute: typeof AuthenticatedOrgIdDashboardRouteRouteWithChildren
  AuthenticatedOrgIdSettingsRouteRoute: typeof AuthenticatedOrgIdSettingsRouteRouteWithChildren
  AuthenticatedOrgIdGroupsRoute: typeof AuthenticatedOrgIdGroupsRoute
  AuthenticatedOrgIdIndexRoute: typeof AuthenticatedOrgIdIndexRoute
  AuthenticatedOrgIdCheckInReportsIdRoute: typeof AuthenticatedOrgIdCheckInReportsIdRoute
  AuthenticatedOrgIdCheckInIdRoute: typeof AuthenticatedOrgIdCheckInIdRoute
  AuthenticatedOrgIdGuardmeIdRoute: typeof AuthenticatedOrgIdGuardmeIdRoute
  AuthenticatedOrgIdIncidentsIdRoute: typeof AuthenticatedOrgIdIncidentsIdRoute
  AuthenticatedOrgIdIncidentsNewRoute: typeof AuthenticatedOrgIdIncidentsNewRoute
  AuthenticatedOrgIdMembersIdRoute: typeof AuthenticatedOrgIdMembersIdRoute
  AuthenticatedOrgIdCheckInReportsIndexRoute: typeof AuthenticatedOrgIdCheckInReportsIndexRoute
  AuthenticatedOrgIdCheckInIndexRoute: typeof AuthenticatedOrgIdCheckInIndexRoute
  AuthenticatedOrgIdGuardmeIndexRoute: typeof AuthenticatedOrgIdGuardmeIndexRoute
  AuthenticatedOrgIdIncidentsIndexRoute: typeof AuthenticatedOrgIdIncidentsIndexRoute
  AuthenticatedOrgIdMembersIndexRoute: typeof AuthenticatedOrgIdMembersIndexRoute
}

const AuthenticatedOrgIdRouteChildren: AuthenticatedOrgIdRouteChildren = {
  AuthenticatedOrgIdDashboardRouteRoute:
    AuthenticatedOrgIdDashboardRouteRouteWithChildren,
  AuthenticatedOrgIdSettingsRouteRoute:
    AuthenticatedOrgIdSettingsRouteRouteWithChildren,
  AuthenticatedOrgIdGroupsRoute: AuthenticatedOrgIdGroupsRoute,
  AuthenticatedOrgIdIndexRoute: AuthenticatedOrgIdIndexRoute,
  AuthenticatedOrgIdCheckInReportsIdRoute:
    AuthenticatedOrgIdCheckInReportsIdRoute,
  AuthenticatedOrgIdCheckInIdRoute: AuthenticatedOrgIdCheckInIdRoute,
  AuthenticatedOrgIdGuardmeIdRoute: AuthenticatedOrgIdGuardmeIdRoute,
  AuthenticatedOrgIdIncidentsIdRoute: AuthenticatedOrgIdIncidentsIdRoute,
  AuthenticatedOrgIdIncidentsNewRoute: AuthenticatedOrgIdIncidentsNewRoute,
  AuthenticatedOrgIdMembersIdRoute: AuthenticatedOrgIdMembersIdRoute,
  AuthenticatedOrgIdCheckInReportsIndexRoute:
    AuthenticatedOrgIdCheckInReportsIndexRoute,
  AuthenticatedOrgIdCheckInIndexRoute: AuthenticatedOrgIdCheckInIndexRoute,
  AuthenticatedOrgIdGuardmeIndexRoute: AuthenticatedOrgIdGuardmeIndexRoute,
  AuthenticatedOrgIdIncidentsIndexRoute: AuthenticatedOrgIdIncidentsIndexRoute,
  AuthenticatedOrgIdMembersIndexRoute: AuthenticatedOrgIdMembersIndexRoute,
}

const AuthenticatedOrgIdRouteWithChildren =
  AuthenticatedOrgIdRoute._addFileChildren(AuthenticatedOrgIdRouteChildren)

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountCloseRoute: typeof AuthenticatedAccountCloseRoute
  AuthenticatedAccountMembershipsRoute: typeof AuthenticatedAccountMembershipsRoute
  AuthenticatedAccountNotificationsRoute: typeof AuthenticatedAccountNotificationsRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountCloseRoute: AuthenticatedAccountCloseRoute,
  AuthenticatedAccountMembershipsRoute: AuthenticatedAccountMembershipsRoute,
  AuthenticatedAccountNotificationsRoute:
    AuthenticatedAccountNotificationsRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedOrgIdRoute: typeof AuthenticatedOrgIdRouteWithChildren
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedAssignedIncidentsRoute: typeof AuthenticatedAssignedIncidentsRoute
  AuthenticatedMyIncidentsRoute: typeof AuthenticatedMyIncidentsRoute
  AuthenticatedOrganizationsRoute: typeof AuthenticatedOrganizationsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedOrgIdRoute: AuthenticatedOrgIdRouteWithChildren,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedAssignedIncidentsRoute: AuthenticatedAssignedIncidentsRoute,
  AuthenticatedMyIncidentsRoute: AuthenticatedMyIncidentsRoute,
  AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AuthorizeRoute: AuthorizeRoute,
  SpinnerRoute: SpinnerRoute,
  authSignInRoute: authSignInRoute,
  authSignOutRoute: authSignOutRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  AuthSignoutRoute: AuthSignoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
